import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import Link from '../../../../components/Link';

export const DivStyled = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    height: 100%;
    background-color: ${theme.colors.background.darkTheme.darkDefault};
    overflow-x: hidden;
    position: fixed;
    z-index: ${theme.zIndex.globalNavMain};
    top: 0;
    right: 0;
    width: ${rem(80)};
    height: ${rem(50)};
    ${theme.largeUp()
    && css`
        position: relative;
        top: auto;
        right: auto;
        width: auto;
        height: auto;
      `}
  `}
`;

export const LinkStyledLoginFwm = styled(Link)`
  ${({ theme }) => {
    const largeUp = theme.largeUp();
    const xlargeUp = theme.xlargeUp();

    let thisFontSize = rem(15);

    if (xlargeUp) {
      thisFontSize = rem(13);
    } else if (largeUp) {
      thisFontSize = rem(11);
    }

    return css`
      font-weight: 500;
      padding: ${rem(5)};
      font-size: ${thisFontSize};
      :hover {
        color: ${theme.colors.brand.nm.secondary.sky};
      }
    `;
  }}
`;

export const LinkStyledLogin = styled(Link)`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const largeUp = theme.largeUp();
    let thisPadding = largeUp ? `${rem(10)} ${rem(15)} ${rem(8)}` : 0;
    let thisLineHeight = rem(22);
    let thisFontSize = rem(15);
    const thisDisplay = largeUp ? 'inline-block' : 'flex';

    if (xlargeUp) {
      thisLineHeight = rem(20);
    } else if (largeUp) {
      thisLineHeight = rem(17);
    }

    if (xlargeUp) {
      thisFontSize = rem(13);
    }

    return css`
      && {
        display: ${thisDisplay};
        width: ${largeUp ? 'auto' : rem(80)};
        height: 100%;
        border: none;
        margin: ${largeUp ? '0' : '0 auto'};
        background-color: ${theme.colors.background.darkTheme.darkDefault};
        border-radius: 0;
        color: ${theme.colors.neutral.white};
        padding: ${thisPadding};
        height: auto;
        font-size: ${thisFontSize};
        font-weight: 500;
        line-height: ${thisLineHeight};
        .nmx-icon {
          display: ${largeUp ? 'block' : 'none'};
          margin-top: ${largeUp ? rem(2) : 0};
          float: left;
          .icon-fill {
            fill: ${theme.colors.brand.nm.secondary.sky};
          }
        }
        &:hover,
        &:focus {
          background-color: ${theme.colors.background.darkTheme.darkDefault};
          text-decoration: underline;
          text-underline-offset: ${rem(2)};
          .nmx-icon {
            .icon-fill {
              fill: ${theme.colors.neutral.white};
            }
          }
        }
      }
    `;
  }}
`;
